import { useQuery } from "@tanstack/react-query";
import { RefreshCw } from "lucide-react";

import { Button } from "@/components/ui/button";
import { fetchHealth } from "@/lib/api";
import { BUILD } from "@/lib/build";

/**
 * Footer of every page: the version running in this browser (commit, branch
 * or tag, date; scripts/build-info.sh) and the EDItEUR attribution (LIC-01).
 * If the server already runs another commit, e.g. after a deploy, it asks
 * for a reload.
 */
export function AppFooter() {
  const health = useQuery({ queryKey: ["health"], queryFn: fetchHealth, staleTime: 60_000 });
  const server = health.data?.commit;
  const outdated = !!BUILD.commit && !!server && server !== BUILD.commit;
  const version = [BUILD.version && `Version ${BUILD.version}`, BUILD.ref, BUILD.commit, BUILD.date]
    .filter(Boolean)
    .join(" · ");

  return (
    <footer className="border-t text-xs text-muted-foreground">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center gap-x-6 gap-y-2 px-4 py-3">
        <span data-testid="build">{version || "Version unbekannt"}</span>
        {outdated && (
          <span role="status" className="flex items-center gap-2 text-foreground">
            Auf dem Server läuft eine andere Version ({server}).
            <Button variant="outline" size="sm" onClick={() => window.location.reload()}>
              <RefreshCw aria-hidden /> Neu laden
            </Button>
          </span>
        )}
        <span className="sm:ml-auto">
          ONIX, Schemas und Codelisten:{" "}
          <a className="underline" href="https://www.editeur.org" target="_blank" rel="noreferrer">
            EDItEUR
          </a>{" "}
          (
          <a
            className="underline"
            href="https://doi.org/10.4400/nwgj"
            target="_blank"
            rel="noreferrer"
          >
            Lizenz
          </a>
          )
        </span>
      </div>
    </footer>
  );
}
